import Aditya_Birla from "../../assets/Aditya_birla.png";
import Ultratech from "../../assets/Ultratech.png";
import Times from "../../assets/Times.png";
import STL from "../../assets/STL.png";
import ftprotech from "../../assets/OurClients/ftportech.png";
import blumetra from "../../assets/OurClients/blumetro.png";
import bridgewest from "../../assets/OurClients/bridegwest.png";
import gttech from "../../assets/OurClients/gttech.png";
import ikf from "../../assets/OurClients/ikf.png";
import incuspace from "../../assets/OurClients/incuspaze.png";
import jef from "../../assets/OurClients/jef.png";
import jemysto from "../../assets/OurClients/jemysto.png";
import mizzen from "../../assets/OurClients/mizzen.png";
import mmnove from "../../assets/OurClients/mmnove.png";
import proplus from "../../assets/OurClients/proplus.png";
import scogo from "../../assets/OurClients/scogo.png";
import shaily from "../../assets/OurClients/shaily.png";
import smartwinner from "../../assets/OurClients/smartwinner.png";
import testpan from "../../assets/OurClients/testpan.png";
import zooper from "../../assets/OurClients/zooper.png";
import aristo from "../../assets/OurClients/aristo.png";
import mehtagold from "../../assets/OurClients/mehtagold.png";
import bluecoin from "../../assets/OurClients/bluecoin.png";
import securitylit from "../../assets/OurClients/securitylit.png";
import proplusdata from "../../assets/OurClients/proplusdata.png";
import skyroot from "../../assets/OurClients/skyroote.png";
import apollo from '../../assets/OurClients/applo_logo.png'
import jeysto from '../../assets/OurClients/jeysto.jpeg'
const digitalOceanURL =
  "https://hirestarorg.blr1.digitaloceanspaces.com/Hirestar-Landing-Page/assets";

const LeftArrayLogo = [
  {
    img: blumetra,
    clientName: "blue_metra Logo",
  },
  {
    img: Aditya_Birla,
    clientName: "Aditya Birla Logo",
  },
  {
    img: apollo,
    clientName: "Apollo Homecare",
  },

  {
    img: `${digitalOceanURL}/Clients_PNG/avani.jpeg`,
    clientName: "Avani Logo",
  },
  {
    img: bridgewest,
    clientName: "bridgewest Logo",
  },
  {
    img: `${digitalOceanURL}/Clients_PNG/Appzest.png`,
    clientName: "Appzest Logo",
  },
  {
    img: mizzen,
    clientName: "mizzen Logo",
  },
  {
    img: mmnove,
    clientName: "mmnove Logo",
  },
  {
    img: `${digitalOceanURL}/Clients_PNG/ChitMonks-logo.png`,
    clientName: "ChitMonks Logo",
  },
  {
    img: proplus,
    clientName: "proplus Logo",
  },
  {
    img: gttech,
    clientName: "gt_technology Logo",
  },
  {
    img: `${digitalOceanURL}/Clients_PNG/bluesemi-logo.png`,
    clientName: "Bluesemi Logo",
  },
  {
    img: ikf,
    clientName: "ikf Logo",
  },
  {
    img: incuspace,
    clientName: "incuspace Logo",
  },
  {
    img: `${digitalOceanURL}/Clients_PNG/crome-check-logo.png`,
    clientName: "Crome Check Logo",
  },
  {
    img: `${digitalOceanURL}/Clients_PNG/elogix-logo.png`,
    clientName: "Elogix Logo",
  },
  {
    img: jef,
    clientName: "jef Logo",
  },
  {
    img: Ultratech,
    clientName: "Ultratech Logo",
  },
  {
    img: `${digitalOceanURL}/Clients_PNG/t-hub-logo.png`,
    clientName: "T-Hub Logo",
  },
  {
    img: jemysto,
    clientName: "jemysto Logo",
  },
  {
    img: `${digitalOceanURL}/Clients_PNG/monitra-logo.png`,
    clientName: "Monitra Logo",
  },
  {
    img: `${digitalOceanURL}/Clients_PNG/AriqT-logo.png`,
    clientName: "AriqT Logo",
  },
  { img: `${digitalOceanURL}/Clients_PNG/JNTU.png`, clientName: "JNTU Logo" },
  {
    img: `${digitalOceanURL}/Clients_PNG/appstek_corp_logo.png`,
    clientName: "Appstek Corp Logo",
  },
  {
    img: `${digitalOceanURL}/Clients_PNG/icici-bank-logo.png`,
    clientName: "ICICI Bank Logo",
  },
  {
    img: `${digitalOceanURL}/Clients_PNG/image 48.png`,
    clientName: "J-Hub Logo",
  },
  {
    img: `${digitalOceanURL}/Clients_PNG/image 49.png`,
    clientName: "Ten-thousand startups Logo",
  },
  //   {
  //     img: `${digitalOceanURL}/Clients_PNG/image 50.png`,
  //     clientName: "Startup india ",
  //   },
  {
    img: ftprotech,
    clientName: "ftprotech Logo",
  },
  {
    img: `${digitalOceanURL}/Clients_PNG/startupindia.png`,
    clientName: "Startup India Logo",
  },
  {
    img: `${digitalOceanURL}/Clients_PNG/startups.png`,
    clientName: "Startups Logo",
  },
  { img: `${digitalOceanURL}/deal_logo.svg`, clientName: "Deal Logo" },
  { img: `${digitalOceanURL}/NewClients/defa.svg`, clientName: "Defa Logo" },
  { img: `${digitalOceanURL}/NewClients/hpl.svg`, clientName: "HPL Logo" },
  {
    img: `${digitalOceanURL}/NewClients/91springboard.svg`,
    clientName: "91springboard Logo",
  },
  { img: `${digitalOceanURL}/NewClients/blix.svg`, clientName: "Blix Logo" },
  { img: `${digitalOceanURL}/NewClients/goken.svg`, clientName: "Goken Logo" },
  {
    img: `${digitalOceanURL}/NewClients/jewelbox.svg`,
    clientName: "Jewelbox Logo",
  },
  {
    img: `${digitalOceanURL}/NewClients/nasscom.svg`,
    clientName: "Nasscom Logo",
  },
  {
    img: `${digitalOceanURL}/NewClients/phenom.svg`,
    clientName: "Phenom Logo",
  },
  { img: `${digitalOceanURL}/NewClients/sps.svg`, clientName: "SPS Logo" },
  { img: `${digitalOceanURL}/NewClients/tfg.svg`, clientName: "TFG Logo" },
  {
    img: `${digitalOceanURL}/NewClients/trade-fantasy.svg`,
    clientName: "Trade Fantasy Logo",
  },
  { img: `${digitalOceanURL}/NewClients/volta.svg`, clientName: "Volta Logo" },
];

const RightArrayLogo = [
  {
    img: Times,
    clientName: "Times Logo",
  },
  {
    img: proplusdata,
    clientName: "proplusdata Logo",
  },
  {
    img: jeysto,
    clientName: "jeysto",
  },
  {
    img: skyroot,
    clientName: "skyroot Logo",
  },

  {
    img: scogo,
    clientName: "scogo Logo",
  },
  {
    img: `${digitalOceanURL}/NewClients/nasscom.svg`,
    clientName: "Nasscom Logo",
  },
  {
    img: shaily,
    clientName: "shaily Logo",
  },
  {
    img: `${digitalOceanURL}/Clients_PNG/elogix-logo.png`,
    clientName: "Elogix Logo",
  },
  {
    img: smartwinner,
    clientName: "smartwinn Logo",
  },
  {
    img: bluecoin,
    clientName: "blue_coin Logo",
  },
  {
    img: `${digitalOceanURL}/Clients_PNG/image 48.png`,
    clientName: "J-Hub Logo",
  },
  {
    img: `${digitalOceanURL}/Clients_PNG/monitra-logo.png`,
    clientName: "Monitra Logo",
  },
  {
    img: testpan,
    clientName: "testpan Logo",
  },
  {
    img: `${digitalOceanURL}/Clients_PNG/kanerika.png`,
    clientName: "Kanerika Logo",
  },
  {
    img: zooper,
    clientName: "zooper Logo",
  },
  {
    img: `${digitalOceanURL}/Clients_PNG/crome-check-logo.png`,
    clientName: "Crome Check Logo",
  },
  { img: `${digitalOceanURL}/NewClients/sps.svg`, clientName: "SPS Logo" },
  {
    img: `${digitalOceanURL}/NewClients/jewelbox.svg`,
    clientName: "Jewelbox Logo",
  },
  {
    img: `${digitalOceanURL}/NewClients/phenom.svg`,
    clientName: "Phenom Logo",
  },
  {
    img: `${digitalOceanURL}/Clients_PNG/ChitMonks-logo.png`,
    clientName: "ChitMonks Logo",
  },
  {
    img: securitylit,
    clientName: "securitylit Logo",
  },
  {
    img: `${digitalOceanURL}/Clients_PNG/image 49.png`,
    clientName: "Ten-thousand startups Logo",
  },
  { img: `${digitalOceanURL}/NewClients/hpl.svg`, clientName: "HPL Logo" },
  {
    img: `${digitalOceanURL}/Clients_PNG/startupindia.png`,
    clientName: "Startup India Logo",
  },
  {
    img: STL,
    clientName: "STL Logo",
  },
  {
    img: `${digitalOceanURL}/Clients_PNG/icici-bank-logo.png`,
    clientName: "ICICI Bank Logo",
  },
  {
    img: `${digitalOceanURL}/NewClients/trade-fantasy.svg`,
    clientName: "Trade Fantasy Logo",
  },
  {
    img: `${digitalOceanURL}/Clients_PNG/startups.png`,
    clientName: "Startups Logo",
  },
  { img: `${digitalOceanURL}/NewClients/volta.svg`, clientName: "Volta Logo" },
  {
    img: `${digitalOceanURL}/Clients_PNG/AriqT-logo.png`,
    clientName: "AriqT Logo",
  },
  {
    img: `${digitalOceanURL}/Clients_PNG/avani.jpeg`,
    clientName: "Avani Logo",
  },
  {
    img: `${digitalOceanURL}/Clients_PNG/Appzest.png`,
    clientName: "Appzest Logo",
  },
  { img: `${digitalOceanURL}/Clients_PNG/JNTU.png`, clientName: "JNTU Logo" },
  { img: `${digitalOceanURL}/NewClients/goken.svg`, clientName: "Goken Logo" },
  {
    img: `${digitalOceanURL}/Clients_PNG/bluesemi-logo.png`,
    clientName: "Bluesemi Logo",
  },
  {
    img: `${digitalOceanURL}/NewClients/91springboard.svg`,
    clientName: "91springboard Logo",
  },
  {
    img: aristo,
    clientName: "aristo Logo",
  },
  { img: `${digitalOceanURL}/NewClients/blix.svg`, clientName: "Blix Logo" },
  { img: `${digitalOceanURL}/NewClients/tfg.svg`, clientName: "TFG Logo" },
  { img: `${digitalOceanURL}/deal_logo.svg`, clientName: "Deal Logo" },
  { img: `${digitalOceanURL}/NewClients/defa.svg`, clientName: "Defa Logo" },
  {
    img: `${digitalOceanURL}/Clients_PNG/appstek_corp_logo.png`,
    clientName: "Appstek Corp Logo",
  },
  {
    img: mehtagold,
    clientName: "mehtagold Logo",
  },
  {
    img: `${digitalOceanURL}/Clients_PNG/t-hub-logo.png`,
    clientName: "T-Hub Logo",
  },
];

// console.log(LeftArrayLogo);
export { LeftArrayLogo, RightArrayLogo };
